import React from "react";
import Loaders from "components/Common/Loaders";
import { usePermissionContext } from "libs/context/PermissionContext";
import AccountExecutiveWeeklyDashboard from "./AccountExecutiveWeeklyDashboard";
import BackendDashboard from "./BackendDashboard";
import SuperAdminDashboard from "./SuperAdminDashboard";
import RecruiterDashboard from "./RecruiterDashboard";

const BACKEND_USER_TYPE_IDS = new Set([5, 6, 8, 13, 14, 15, 17]);
const SUPER_ADMIN_USER_TYPE_IDS = new Set([1, 2, 3, 4, 11]);
const ACCOUNT_EXECUTIVE_USER_TYPE_ID = 12;

export { BACKEND_USER_TYPE_IDS };

export function resolveLoggedInUserData() {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user && typeof user === "object" ? user : null;
  } catch (_e) {
    return null;
  }
}

export function resolveLoggedInUserTypeId() {
  try {
    const user = resolveLoggedInUserData();
    if (!user) return null;

    const nested = user.user && typeof user.user === "object" ? user.user : null;
    const id = Number(
      user.userTypeId ??
        user.UserTypeId ??
        nested?.userTypeId ??
        nested?.UserTypeId
    );
    return Number.isFinite(id) ? id : null;
  } catch (_e) {
    return null;
  }
}

const RoleBasedDashboard = () => {
  const { initialized, loading } = usePermissionContext() || {};

  if (!initialized || loading) {
    return <Loaders />;
  }

  const userTypeId = resolveLoggedInUserTypeId();

  if (BACKEND_USER_TYPE_IDS.has(userTypeId)) {
    return <RecruiterDashboard />;
  }

  if (userTypeId === ACCOUNT_EXECUTIVE_USER_TYPE_ID) {
    return <AccountExecutiveWeeklyDashboard />;
  }

  if (SUPER_ADMIN_USER_TYPE_IDS.has(userTypeId)) {
    return <SuperAdminDashboard />;
  }

  return <SuperAdminDashboard />;
};

export default RoleBasedDashboard;
